import React, { useEffect, useState, useCallback } from "react";
import { Box } from "ui-components";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { paths } from "utils/constants";
import { clearLocalStorage, getItem, getRequestId } from "utils/localStorage";
import { buildStoredJumioAuthHeaders, gotoUrl } from "utils/helpers";
import { renderPageComponents } from "containers/SmartRender";
import OrderConfirmation from "components/EnterpriseAutomated/OrderConfirmation/index";
import OrderInfoSection from "components/EnterpriseAutomated/OrderInfoSection/index";
import PageFaqs from "components/EnterpriseAutomated/PageFaqs/index";
import { createEnterpriseWorkFlow } from "ducks/actions/index";
import { createStructuredSelector } from "../../../../../node_modules/reselect/es/index";
import { connect } from "react-redux";

const PaymentSuccess = props => {
  const {
    appSettings,
    idVerificationStatus,
    pageData,
    orderRef,
    createEnterpriseWorkFlow: callCreateEnterpriseWorkFlow,
    id,
    paymentStatus,
  } = props;
  const [showVideo, setShowVideo] = useState(false);
  const isIdentityVerificationCheckEnabled = get(
    appSettings,
    "identity_verification_status_check.payment_return",
    false
  );

  const smartComponents = renderPageComponents({
    pageComponents: get(
      pageData,
      "nested_container_components.PaymentSuccess.components"
    ),
    pageProps: props
  });

  if (
    isIdentityVerificationCheckEnabled &&
    !idVerificationStatus &&
    getItem("checkDvsStatus")
  ) {
    gotoUrl(paths.IDENTITY_VERIFICATION, true); // url, preserveQuery
  }
  if (getItem("checkDvsStatus")) {
    setTimeout(() => {
      clearLocalStorage();
    }, 1000);
  }

  const videoHandler = useCallback(
    event => {
      if (event.target.className === "video_container") return;
      if (showVideo) {
        setShowVideo(false);
      }
    },
    [showVideo]
  );

  useEffect(
    () => {
      window.addEventListener("click", videoHandler);
      return () => {
        window.removeEventListener("click", videoHandler);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [showVideo, videoHandler]
  );

   useEffect(() => {
    const headersValue = buildStoredJumioAuthHeaders();
    const payload = {
      workflow: "payment_success",
      request_id: getRequestId(),
      status: "success",
      metadata: {
        id:id || "",
        paymentStatus:paymentStatus || "",
        orderRef:orderRef
      }
    };
    callCreateEnterpriseWorkFlow(headersValue,payload, () => {})
    // eslint-disable-next-line
  },[])

  // const hidePlayer = () => setShowVideo(false);

  // const showPlayer = () => setShowVideo(true);

  // const renderFaqButton = () => (
  //   <Button
  //     as="a"
  //     href={ESIM_FAQ_URL}
  //     sx={{
  //       padding: "12px 50px"
  //     }}
  //   >
  //     <FormattedMessage id="payment_success_see_faqs" />
  //   </Button>
  // );

  // const onActionClicked = (
  //   action,
  //   anchorTarget,
  //   fullyQualifiedURL
  // ) => {
  //   const URLToUse = fullyQualifiedURL
  //     ? fullyQualifiedURL
  //     : get(find(orderActions, { action }) || {}, "url", "");

  //   if (anchorTarget === "_self") {
  //     gotoUrl(URLToUse);
  //   } else {
  //     window.open(URLToUse, anchorTarget);
  //   }
  // };

  if (!isEmpty(smartComponents)) {
    return (
      <Box data-testid="payment-success" pt="4" variant="main" padding={[4, 6]}>
        {smartComponents}
      </Box>
    );
  }

  return (
    <>
      <OrderConfirmation orderRef={orderRef ? orderRef : "" }  />
      <OrderInfoSection />
      <PageFaqs 
          faq={[
            {
              answer:
                "Your Data will be autoboosted in increments of 200 MB. Affordable <a href='https://circlesasiasupport.zendesk.com/hc/en-us/articles/218254748-Does-Circles-Life-have-a-Pay-As-You-Go-plan-' target='_blank'>Pay-as-you-go</a> rates will apply for exceeding Talktime and SMS.",
              question: "What happens if I exceed my Plan?"
            },
            {
              answer:
                "Travel and pay for only what you use, no matter where you are in the world. <div><a href='https://circlesasiasupport.zendesk.com/hc/en-us/articles/115000101913-What-are-the-PAYG-roaming-rates-' target='_blank'>See rates</a></div>",
              question: "Roaming"
            },
            {
              answer: "eligible_to_transfer_number_answer",
              question: "eligible_to_transfer_number_question"
            }
          ]}
          title="most_asked_questions"
      />
    </>
  );
};

export function mapDispatchToProps(dispatch) {
  return {
    createEnterpriseWorkFlow: (headersValue, params) => {
      dispatch(createEnterpriseWorkFlow(headersValue, params));
    },
  }
}
const mapStateToProps = createStructuredSelector({});
export default connect(mapStateToProps,mapDispatchToProps)(PaymentSuccess);
